import axios from 'axios';
const authApiUrl = process.env.VUE_APP_API_URL;

const state = {
  token: localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null,
  accountType: localStorage.getItem('acc') || null,
  managerProfile: {
    description: '',
    benefits: '',
  },
  managerUserProfile: {},
  managerJobs: [],
  managerJobByID: {
    description: '',
    id: '',
    country: { name: '' },
    city: { name: '' },
  },
  jobsDropdown: [],
  totalPages: 0,
  currentPage: 1,
  nextPage: null,
  managerCandidates: [],
  managerCandidatesMobile: [],
  managerJobAcivities: [],
  managerCandidateById: {
    activities: [],
    address: {
      address: '',
      city: '',
      country: '',
      latitude: null,
      longitude: null,
      postal_code: '',
    },
    manager: {
      country: { name: '' },
      city: { name: '' },
      address: {
        address: '',
        city: '',
        country: '',
        latitude: null,
        longitude: null,
        postal_code: '',
      },
    },
    languages: [],
    competences: [],
  },
  managerCandidatePipelines: [],
  managerCandidateDocuments: [],
  managerCandidateActivities: [],
  managerCandidateComments: [],
  managerCandidateAvatar: '',
  managerPipelines: [],
  pipelinesForJob: [],

  jobPipelines: {
    data: [],
  },
  managerComments: [],
  managerComment: {},
  managerCommentsList: [],

  chartOneData: [],
  funnelOneData: [],
  recentPlacements: [],
  recent: [],
  /* MESSAGES */
  successMessage: '',
  errorMessage: '',

  guide: {
    show: false,
    step: 1,
  },
};

const getters = {
  getToken: state => state.token,
  getManagerProfile: state => state.managerProfile,
  getManagerUserProfile: state => state.managerUserProfile,
  getManagerJobs: state => state.managerJobs,
  getManagerJobByID: state => state.managerJobByID,
  getNextPage: state => state.nextPage,
  getTotalPages: state => state.totalPages,
  getCurrentPage: state => state.currentPage,
  getManagerJobsDropdown: state => state.jobsDropdown,
  getManagerCandidates: state => state.managerCandidates,
  getManagerCandidatesMobile: state => state.managerCandidatesMobile,
  getManagerPipelines: state => state.managerPipelines,
  getManagerJobPipelines: state => state.jobPipelines,
  getManagerComments: state => state.managerComments,
  getManagerCandidateById: state => state.managerCandidateById,
  getManagerCandidatePipelines: state => state.managerCandidatePipelines,
  getManagerCandidateDocuments: state => state.managerCandidateDocuments,
  getManagerCandidateActivities: state => state.managerCandidateActivities,
  getManagerJobActivities: state => state.managerJobAcivities,
  getManagerCandidateAvatar: state => state.managerCandidateAvatar,
  getManagerCandidateComments: state => state.managerCandidateComments,

  getManagerCommentsList: state => state.managerCommentsList,
  getManagerChartOneData: state => state.chartOneData,
  getManagerFunnelOneData: state => state.funnelOneData,
  getManagerRecentPlacements: state => state.recentPlacements,
  getManagerRecent: state => state.recent,

  /* Errors */
  getErrorMessage: state => state.errorMessage,
  getGuide: state => state.guide,
};

/* Retrieve Token */
// const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

const actions = {
  /* Pipelines */
  updateManagerDndPipelines(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/pipelines/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Pipelines */
  updateManagerEmployerById(_, payload) {
    const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerUserProfile({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios
        .get(`${authApiUrl}/manager/userprofile/index`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setManagerUserProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerProfile({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios
        .get(`${authApiUrl}/manager/profile`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setManagerProfile', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobs({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobs/index`, {
        method: 'post',
        data: {
          search_word: payload.search_word,
          page: Number(payload.page),
          count: Number(payload.count),
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { next_page_url, current_page, last_page } = response.data;
          const totalPages = last_page;

          commit('setManagerJobs', response.data.data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(totalPages));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobById({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobs/viewjob/${payload.jobID}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setManagerJobByID', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobAdByIdForCopyExisting(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobs/viewjob/${payload.jobID}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobsDropdown({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobs/dropdown`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
        params: {
          all_jobs: 0,
        },
      })
        .then(response => {
          commit('setManagerManagerJobsDropdown', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveManagerJobsDropdownPipe({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobs/dropdown`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
        params: {
          all_jobs: 1,
        },
      })
        .then(response => {
          commit('setManagerManagerJobsDropdown', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateManagerJobAdById(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;
      axios(`${authApiUrl}/manager/jobs/update`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* CANDIDATES */
  retrieveManagerCandidates({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/candidates/index`, {
        method: 'post',
        data: {
          /*  search_word: payload.search_word,
          page: payload.page,
          count: payload.count, */
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { next_page_url, current_page, last_page } = response.data;
          const totalPages = last_page;

          commit('setManagerCandidates', response.data.data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(totalPages));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveManagerCandidateById({ commit }, { manager_candidate_id }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios
        .get(`${authApiUrl}/manager/candidates/view/${manager_candidate_id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          const candidate = response.data;
          const candidateDocuments = response.data.documents;

          commit('setManagerCandidateById', candidate);
          commit('setManagerCandidateDocuments', candidateDocuments);
          /*  commit('setManagerCandidateActivities', activities); */

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerPipelines({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/pipelines/index`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setManagerManagerPipelines', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerPipelinesForJob({ commit }, jobAdID) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/pipelines/forjob/${jobAdID}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          console.log('retrieveManagerPipelinesForJob: ', response.data);

          commit('setManagerManagerPipelinesForJob', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerCandidatePipelines({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;
      axios(`${authApiUrl}/manager/pipelines/forcandidate`, {
        method: 'post',
        data: {
          candidate_id: payload.uuid,
          search_word: payload.search_word,
          page: payload.page,
          count: payload.count,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { data, next_page_url, current_page, last_page } = response.data;

          commit('setManagerCandidatePipelines', data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(last_page));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerCandidateDocumentPreview(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;
      axios
        .get(`${authApiUrl}/manager/candidates/preview/document/${payload.uuid}`, {
          params: {
            preview: payload.preview,
          },
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          // commit('setDocumentPreview', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  retrieveManagerCandidateActivities({ commit }, payload) {
    const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/manager/activity/forcandidate/${payload.uuid}`, {
          params: {
            page: payload.page,
            count: payload.count,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setManagerCandidateActivities', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* END CANDIDATES */

  /* JOBS */
  ManagerAddJob(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      const {
        title,
        description,
        country_id,
        city_id,
        street,
        postal_code,
        employment_type,
        years_experience,
        degree_type,
        competences,
        advantage_competences,
        languages,
        relocation,
        service_level,
        advertizing_start_date,
        advertizing_end_date,
        note,
        degree_field,
        status,
        individuals_number,
        full_time,
        duration,
        summary,
        workplace,
        eu_vat_number,
        invoice_email,
        registration_number,
      } = payload;

      axios(`${authApiUrl}/manager/jobs/create`, {
        method: 'post',
        data: {
          title,
          description,
          country_id,
          city_id,
          street,
          postal_code,
          employment_type,
          years_experience,
          degree_type,
          degree_field,
          competences,
          advantage_competences,
          languages,
          relocation,
          service_level,
          advertizing_start_date,
          advertizing_end_date,
          note,
          status,
          individuals_number,
          full_time,
          duration,
          summary,
          workplace,
          eu_vat_number,
          invoice_email,
          registration_number,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobPipelines({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/pipelines/paginatedforjob`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setManagerManagerJobPipelines', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateManagerJobPipeline(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/pipelines/update`, {
        method: 'post',
        data: {
          pipeline_id: payload.pipeline_id,
          stage: payload.stage,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          // commit('setManagerManagerJobPipelines', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerCommentsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobcomments/list/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const comments = response.data;
          commit('setManagerComments', comments);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addManagerComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobcomments/create`, {
        method: 'post',
        data: {
          jobad_id: payload.uuid,
          data: payload.message,
          js_share: payload.js_share,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setComment', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  editManagerComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/jobcomments/update`, {
        method: 'post',
        data: {
          comment_id: payload.uuid,
          data: payload.data,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { statusText } = response;
          commit('setSuccessMessage', statusText);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeManagerComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/jobcomments/delete/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setManagerCommentRemoved', response);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  updateActivity({ state }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/activity/update`, {
        method: 'post',
        data: {
          activity_id: payload.activity_id,
          comment: payload.activity_comment,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  addManagerActivity(_, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/activity/create`, {
        method: 'post',
        data: {
          jobad_id: payload.jobad_id,
          candidate_id: payload.candidate_id,
          comment: payload.comment,
        },
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerJobActivities({ commit }, payload) {
    const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;
    return new Promise((resolve, reject) => {
      axios
        .get(`${authApiUrl}/manager/activity/forjob/${payload.uuid}`, {
          params: {
            jobad_id: payload.uuid,
            page: payload.page,
            count: payload.count,
          },
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(response => {
          commit('setManagerJobActivities', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  /* End Jobs */

  /* Candidate comments */
  retrieveManagerCandidateCommentsList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/candidatecomments/list/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const comments = response.data;
          commit('setManagerCandidateComments', comments);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  addManagerCandidateComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/candidatecomments/create`, {
        method: 'post',
        data: {
          candidate_id: payload.uuid,
          data: payload.message,
          js_share: payload.js_share,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setComment', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  editManagerCandidateComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/candidatecomments/update`, {
        method: 'post',
        data: {
          comment_id: payload.uuid,
          data: payload.data,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { statusText } = response;
          commit('setSuccessMessage', statusText);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  removeManagerCandidateComment({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios(`${authApiUrl}/manager/candidatecomments/delete/${payload.uuid}`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${state.token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setManagerCommentRemoved', response);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* Dashboard */
  retrieveManagerCharOnetData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/dashboard/toplinechart`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setChartOneData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerFunnelOneData({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/dashboard/funnel`, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setFunnelOneData', response.data);

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  retrieveManagerRecentPlacements({ commit }, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/dashboard/recentplacements`, {
        method: 'get',
        params: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          const { next_page_url, current_page, last_page } = response.data;

          commit('setRecentPlacements', response.data.data);
          commit('setNextPage', next_page_url);
          commit('setTotalPages', Number(last_page));
          commit('setCurrentPage', Number(current_page));

          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* End Dashboard */

  /* Recent */
  retrieveManagerRecent({ commit }) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/recentseen/list `, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          commit('setRecent', response.data);
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },
  sendManagerRecent(_, payload) {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem(`${process.env.VUE_APP_TOKEN_PREFIX}token`) || null;

      axios(`${authApiUrl}/manager/recentseen/store `, {
        method: 'post',
        data: {
          ...payload,
        },
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(response => {
          resolve(response);
        })
        .catch(err => {
          reject(err);
        });
    });
  },

  /* End Recent */

  setGuideStep({ commit }, newStep) {
    commit('SET_GUIDE_STEP', newStep);
  },
};

const mutations = {
  setManagerProfile: (state, managerProfile) => (state.managerProfile = managerProfile),
  setManagerUserProfile: (state, managerUserProfile) =>
    (state.managerUserProfile = managerUserProfile),
  setManagerJobs: (state, managerJobs) => (state.managerJobs = managerJobs),
  setManagerJobByID: (state, managerJobByID) => (state.managerJobByID = managerJobByID),
  setNextPage: (state, nextPage) => (state.nextPage = nextPage),
  setTotalPages: (state, totalPages) => (state.totalPages = totalPages),
  setCurrentPage: (state, currentPage) => (state.currentPage = currentPage),
  setManagerManagerJobsDropdown: (state, jobsDropdown) => (state.jobsDropdown = jobsDropdown),
  setManagerCandidates: (state, managerCandidates) => (state.managerCandidates = managerCandidates),
  setManagerCandidatesMobile: (state, managerCandidatesmobile) =>
    (state.managerCandidatesMobile = [
      ...state.managerCandidatesMobile,
      ...managerCandidatesmobile,
    ]),

  setManagerManagerPipelines: (state, managerPipelines) =>
    (state.managerPipelines = managerPipelines),
  setManagerManagerPipelinesForJob: (state, pipelinesForJob) =>
    (state.pipelinesForJob = pipelinesForJob),
  setManagerManagerJobPipelines: (state, jobPipelines) => (state.jobPipelines = jobPipelines),
  setManagerComments: (state, managerComments) => (state.managerComments = managerComments),
  setManagerCandidateComments: (state, managerCandidateComments) =>
    (state.managerCandidateComments = managerCandidateComments),
  setComment: (state, managerComment) => (state.managerComment = managerComment),
  setSuccessMessage: (state, statusText) => (state.successMessage = statusText),
  setManagerCommentRemoved: (state, managerCommentRemoved) =>
    (state.managerCommentRemoved = managerCommentRemoved),

  setManagerCandidateById: (state, candidate) => (state.managerCandidateById = candidate),
  setManagerCandidatePipelines: (state, pipelines) => (state.managerCandidatePipelines = pipelines),
  setManagerCandidateDocuments: (state, documents) => (state.managerCandidateDocuments = documents),
  setManagerCandidateActivities: (state, activities) =>
    (state.managerCandidateActivities = activities),
  setManagerJobActivities: (state, activities) => (state.managerJobAcivities = activities),
  setChartOneData: (state, chartOneData) => (state.chartOneData = chartOneData),
  setFunnelOneData: (state, funnelOneData) => (state.funnelOneData = funnelOneData),
  setRecentPlacements: (state, recentPlacements) => (state.recentPlacements = recentPlacements),
  setRecent: (state, recent) => (state.recent = recent),

  SET_GUIDE_STEP(state, newStep) {
    state.guide.step = newStep;
  },
  SET_GUIDE_SHOW(state, showValue) {
    state.guide.show = showValue;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
